import { Component, OnInit } from '@angular/core';

// Rxjs dependencies
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

// Store
import { Store } from '@ngrx/store';
import { AppState, selectLevel } from '../../store.module';

// App dependencies.
import { Creep } from '../../creep';

@Component({
  selector: 'app-account-level',
  templateUrl: './account-level.component.html',
  styleUrls: ['./account-level.component.scss']
})
export class AccountLevelComponent implements OnInit {
  public level$: Observable<number>;

  constructor(
    private _store: Store<AppState>
  ) {
    this.level$ = this._store.select(selectLevel);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-main.module/account-level.component/account-level.component.ts